/**
 * frontend/src/utils/rewardSounds.js
 * SoundDAO Sprint 4 finale — tiered Web Audio API reward sounds.
 *
 * Plays a distinct sound for each login reward tier using the Web Audio API.
 * Respects the user's `sounddao_mute_sfx` localStorage setting.
 * All errors are silently swallowed so audio never blocks the UI.
 */

export function playRewardSound(tier) {
  try {
    const ctx   = new (window.AudioContext || window.webkitAudioContext)();
    const muted = localStorage.getItem('sounddao_mute_sfx') === 'true';
    if (muted) return;

    // plays(freq, startOffset, duration, vol)
    const plays = (freq, start, dur, vol = 0.3) => {
      const osc  = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, ctx.currentTime + start);
      gain.gain.setValueAtTime(vol, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + dur);
    };

    if (tier === 'welcome' || tier === 'small') {
      plays(523, 0, 0.4);                                           // C5 single chime
    } else if (tier === 'medium') {
      plays(523, 0, 0.25); plays(659, 0.15, 0.35);                  // C5 E5
    } else if (tier === 'large') {
      plays(523, 0, 0.2); plays(659, 0.12, 0.2);
      plays(784, 0.24, 0.2); plays(1047, 0.36, 0.4);               // C5 E5 G5 C6
    } else if (tier === 'rare') {
      plays(523, 0, 0.15);  plays(659, 0.1, 0.15);
      plays(784, 0.2, 0.15); plays(1047, 0.3, 0.15);
      plays(1319, 0.4, 0.5, 0.4);                                   // ascending to E6
    } else if (tier === 'epic') {
      [523, 587, 659, 698, 784, 880, 988, 1047].forEach(
        (f, i) => plays(f, i * 0.08, 0.25, 0.35)
      );                                                             // full major scale
    } else if (tier === 'jackpot') {
      [523, 659, 784, 1047, 1319, 1568, 2093].forEach(
        (f, i) => plays(f, i * 0.1, 0.4, 0.5)
      );
      setTimeout(() => {
        [1047, 1319, 1568, 2093].forEach(
          (f, i) => plays(f, i * 0.08, 0.5, 0.6)
        );
      }, 900);
    }
  } catch (_) {
    // AudioContext unavailable or blocked — silent fallback
  }
}
